import React from 'react'
import Link from 'next/link';
import { RiEyeLine, RiYoutubeLine } from 'react-icons/ri';
import moment from 'moment';
import ImageWithFallback from '@/Component/Common/ImageWithFallback';
import { CommentsSVG, InstagramLikesSVG, SelectPostSVG } from '@/Component/Common/SVGs/CommonSVG';
import { formatNumber } from '@/Utils/Other/FormateNumbers';

const YoutubePostGrid = (props) => {
    const { posts, selectedPosts, togglePostSelection, lastPostRef } = props;
    return (
        <div className="grid 2xl:grid-cols-3 md:grid-cols-2 grid-cols-1 gap-3">
            {posts?.map((post, index) => {
                const permalink = `https://www.youtube.com/watch?v=${post?.id}`;
                const isSelected = selectedPosts.some((p) => p.post_link === permalink);
                const thumbnails = post?.snippet?.thumbnails;
                const thumbnailUrl =
                    thumbnails?.maxres?.url ||
                    thumbnails?.high?.url ||
                    thumbnails?.medium?.url ||
                    thumbnails?.standard?.url ||
                    thumbnails?.default?.url || '';
                return (
                    <div key={post.id} ref={index === posts.length - 1 ? lastPostRef : null} className="bg-gray/20 rounded-md overflow-hidden aspect-square relative cursor-pointer" onClick={() => togglePostSelection(post)}>
                        {isSelected && <div className="absolute top-2.5 left-2.5 z-10"><SelectPostSVG /></div>}
                        <ImageWithFallback src={thumbnailUrl} alt="Post" className="w-full h-full object-contain" width={500} height={500} />
                        <div className='absolute left-0 right-0 w-full bottom-0 p-3 '>
                            <div className="flex flex-col gap-1 items-start">
                                <div className="bg-black/50 z-10 inline-flex items-center px-2 py-0.5 rounded-lg gap-5">
                                    <span className='text-white font-semibold text-sm'>{moment.utc(post?.snippet?.publishedAt).format("MMMM DD, YYYY")}</span>
                                </div>
                                <div className="bg-black/50 z-10 inline-flex items-center px-2 py-1 rounded-lg gap-3.5">
                                    <div className='flex items-center gap-1.5'>
                                        <InstagramLikesSVG />
                                        <span className='text-white font-semibold text-xs'>{formatNumber(post?.statistics?.likeCount)}</span>
                                    </div>
                                    <div className='flex items-center gap-1.5'>
                                        <CommentsSVG />
                                        <span className='text-white font-semibold text-xs'>{formatNumber(post?.statistics?.commentCount)}</span>
                                    </div>
                                    <div className='flex items-center gap-1.5'>
                                        <RiEyeLine className='text-white text-xl' />
                                        <span className='text-white font-semibold text-xs'>{formatNumber(post?.statistics?.viewCount)}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <Link href={`https://www.youtube.com/watch?v=${post?.id}`} target="_blank" className="absolute top-2.5 right-2.5 bg-black/50 p-1 rounded">
                            <RiYoutubeLine className='text-white text-base' />
                        </Link>
                    </div>)
            })}
        </div>
    )
}

export default YoutubePostGrid
